import { render, staticRenderFns } from "./pageSetting.vue?vue&type=template&id=1b71b4f4&scoped=true"
import script from "./pageSetting.vue?vue&type=script&lang=js"
export * from "./pageSetting.vue?vue&type=script&lang=js"
import style0 from "./pageSetting.vue?vue&type=style&index=0&id=1b71b4f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71b4f4",
  null
  
)

export default component.exports